import { Link } from 'react-router-dom';

interface HeaderProps {
  isAdmin?: boolean;
}

export default function Header({ isAdmin = false }: HeaderProps) {
  return (
    <header className="sticky top-0 z-50">
      {/* Black USC brand bar */}
      <div className="bg-black">
        <div className="container mx-auto px-4 py-3">
          <div className="flex items-center justify-between">
            <div className="flex items-center gap-6">
              <Link to="/" className="flex-shrink-0">
                <img
                  src="/usc-logo-white.svg"
                  alt="University of South Carolina"
                  className="h-10 w-auto"
                  data-testid="usc-logo"
                />
              </Link>
              <div className="hidden sm:block h-8 w-px bg-gray-600" />
              <span className="hidden sm:block text-white text-sm font-medium tracking-wide">
                Division of Information Technology
              </span>
            </div>
          </div>
        </div>
      </div>

      {/* Garnet conference title bar */}
      <div className="bg-usc-garnet">
        <div className="container mx-auto px-4 py-2">
          <div className="flex items-center justify-between">
            <Link to={isAdmin ? '/admin/dashboard' : '/'} className="group">
              <h1 className="text-white font-display text-xl md:text-2xl uppercase tracking-wider">
                {isAdmin ? 'AI Day — Admin Dashboard' : 'AI Day Conference'}
              </h1>
            </Link>
            <span className="hidden md:block text-white/80 text-sm">
              March 19, 2026 · Russell House · Columbia, SC
            </span>
          </div>
        </div>
      </div>
    </header>
  );
}
